module.exports = __webpack_public_path__ + "5748305c9fbbdb414262e8f2042abe23.svg";